module.exports = __webpack_public_path__ + "img/mc_l.bb58d90e.png";